export default {
  UNKNOWN: "unbekannt",
  NONE: "keine",
  VACCINATED: "geimpft",
  PARTIALLY_VACCINATED: "teilweise geimpft / nur Erstimpfung",
  BOOSTERED: "geboostert",
  RECOVERED: "genesen"
};
